import React, { useEffect, useState } from 'react'
import { composeId, convertToKebabCase } from '../../utils'
import { Hint } from '../input/styles'
import { Wrapper } from './styles'
import DDISelector, { DdiSelectorProps } from './ddi-selector'
import FormControl from '../form-control'
import Input from '../input'
import InputLabel from '../input-label'

type Props = {
  'data-qa'?: string
  autoFocus?: boolean
  ddiOptions: DdiSelectorProps[]
  defaultDdiCode?: string
  disabled?: boolean
  hint?: string
  id?: string
  label: string
  mask?: string | RegExp
  maxLength?: number
  minLength?: number
  onChange?: Function
  onDdiChange: Function
  placeholder?: string
  style?: object
  theme?: TTheme
  value: string
}

const PhoneInput: React.FC<Props> = (props: Props): JSX.Element => {
  const [value, setValue] = useState<string>(props.value)
  const id = composeId(props.label)
  const dataQa = `input-${convertToKebabCase(props.label)}`
  const dataQaDdiSelector = convertToKebabCase(props.label)
  const dataQaHint = convertToKebabCase(props.label)

  useEffect(() => {
    if (props.value !== value) setValue(props.value)
  }, [props.value])

  return (
    <FormControl>
      <InputLabel htmlFor={id} text={props.label} />
      <Wrapper style={{ zIndex: 1 }}>
        <DDISelector
          ddiOptions={props.ddiOptions}
          defaultDdiCode={props.defaultDdiCode}
          onDdiChange={props.onDdiChange}
          disabled={props.disabled}
          data-qa={props['data-qa'] || dataQaDdiSelector}
        />
        <Input
          autoFocus={props.autoFocus}
          data-qa={props['data-qa'] || dataQa}
          disabled={props.disabled}
          showLabel={false}
          mask={props.mask}
          maxLength={props.maxLength}
          minLength={props.minLength}
          onChange={props.onChange}
          placeholder={props.placeholder}
          theme={props.theme}
          value={props.value}
        />
      </Wrapper>
      {props.hint && (
        <Hint
          className={`is-${props.theme}`}
          data-qa={`${props['data-qa'] || dataQaHint}-hint`}
        >
          {props.hint}
        </Hint>
      )}
    </FormControl>
  )
}

PhoneInput.defaultProps = {
  mask: '(00) 00000-0000',
  disabled: false,
}

export default PhoneInput

export type TTheme = 'complete' | 'enabled' | 'negative'
